import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { joinKeys } from 'helpers/translations.helper'
import { ExternalCourseModelAPI } from 'models/externalCourse.model'
import { createRouteExternalCourse } from 'enum/routes'
import UploadCertificatesModal from '../../../../common/UploadCertificatesModal'
import { prefixTranslation } from './common'
import { DropdownLoader } from './components/DropdownLoader'
import UploadCertificates from './components/UploadCertificates'
import { DropdownButton, styles } from 'components/ui/DropdownButton'

interface IProps {
  externalCourse: ExternalCourseModelAPI
  onDelete(): void
  onDownload(): void
}

const Options: React.FC<IProps> = ({ externalCourse, onDelete, onDownload }) => {
  const { t } = useTranslation()
  const loading = false
  const [show, setShow] = useState(false)
  const [uploadCertificates, setUploadCertificates] = useState(false)

  const { id } = externalCourse
  const handleDropdownClick = (show: boolean) => {
    setShow(show)
  }

  return (
    <>
      <DropdownButton
        show={show}
        id="dropdown-menu-align-right"
        alignRight
        title={<DropdownLoader loading={loading} />}
        onClick={() => handleDropdownClick(!show)}
        onToggle={() => handleDropdownClick(!show)}
      >
        {
          <Link to={createRouteExternalCourse({ id: `${id}` })}>
            {t(joinKeys(prefixTranslation, 'preview'))}
          </Link>
        }
        {
          <UploadCertificates
            className={styles['option-item']}
            onClick={() => {
              setUploadCertificates(true)
            }}
          />
        }
        {
          <a onClick={() => onDelete()}>
            {t(joinKeys(prefixTranslation, 'delete'))}
          </a>
        }
        {
          <a onClick={() => onDownload()}>
          {t(joinKeys(prefixTranslation, 'download'))}
        </a>
        }
      </DropdownButton>
      <UploadCertificatesModal
        show={uploadCertificates}
        externalCourse={externalCourse}
        onClose={() => {
          setUploadCertificates(false)
        }}
      />
    </>
  )
}

export default Options
